/** Lowercase, drop punctuation and an ending ellipsis, collapse whitespace — for "same sentence?" checks. */
const comparable = (value?: string | null): string =>
  (value || '')
    .toLowerCase()
    .replace(/(…|\.\.\.)\s*$/u, '')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim()

/**
 * The advising note to show under a headline, or null when it only repeats it. Seeded and imported
 * profiles often start `bioForAdvising` with the same sentence as the headline (`shortBio`), so the
 * card and the profile strip read the line twice (real-data walk #14). A note that starts with the
 * headline — or that the headline already contains — is treated as a repeat.
 */
export const advisingNoteUnlessRepeat = (note?: string | null, headline?: string | null): string | null => {
  const trimmed = (note || '').trim()
  if (!trimmed) {
    return null
  }
  const noteKey = comparable(trimmed)
  const headlineKey = comparable(headline)
  if (!noteKey) {
    return null
  }
  if (headlineKey && (noteKey.startsWith(headlineKey) || headlineKey.startsWith(noteKey))) {
    return null
  }
  return trimmed
}
